import { useAuth } from '@/contexts/AuthContext';
import * as Tabs from '@radix-ui/react-tabs';
import styles from './IntegrationContent.module.scss';
import {
    BigCommerceIntegration,
    GoogleAdsIntegration,
    IntegrationCard, ShopifyIntegration
} from './Integrations';

const salesChannels = [
    {
        title: 'Amazon',
        icon: 'amazon',
        subTitle: 'Use Amazon connector for Bustly',
    },
    {
        title: 'eBay',
        icon: 'ebay',
        subTitle: 'Use eBay connector for Bustly',
    },
    {
        title: 'Etsy',
        icon: 'Etsy',
        subTitle: 'Use Etsy connector for Bustly',
    },
    {
        title: 'WooCommerce',
        icon: 'WooCommerce',
        subTitle: 'Use WooCommerce connector for Bustly',
    },
    {
        title: 'Magento',
        icon: 'magento',
        subTitle: 'Use Magento connector for Bustly',
    },
    {
        title: 'Walmart',
        icon: 'Walmart',
        subTitle: 'Use Walmart connector for Bustly',
    }
];

const adsChannels = [
    {
        title: 'Facebook Ads',
        icon: 'facebook_ads',
        subTitle: 'Use Facebook Ads connector for Bustly',
    },
    {
        title: 'Amazon Ads',
        icon: 'amazon',
        subTitle: 'Use Amazon Ads connector for Bustly',
    },
    {
        title: 'TikTok Ads',
        icon: 'TikTok',
        subTitle: 'Use TikTok Ads connector for Bustly',
    },
    {
        title: 'Pinterest Ads',
        icon: 'pinterest',
        subTitle: 'Use Pinterest Ads connector for Bustly',
    },
    {
        title: 'Snapchat Ads',
        icon: 'Snapchat',
        subTitle: 'Use Snapchat Ads connector for Bustly',
    },
    {
        title: 'Criteo Ads',
        icon: 'criteo',
        subTitle: 'Use Criteo Ads connector for Bustly',
    },
    {
        title: 'Bing Ads',
        icon: 'bing',
        subTitle: 'Use Bing Ads connector for Bustly',
    }
];

export default function IntegrationContent() {
    const { profile } = useAuth();

    // Check if user has connected Shopify store
    const connectedStore = profile?.shopInfos?.find(item => item.physicFlag === 1);

    return (
        <div className={styles.integrationContainer}>
            <Tabs.Root defaultValue="sales" className={styles.tabsRoot}>
                <Tabs.List className={styles.tabsList}>
                    <Tabs.Trigger value="sales" className={styles.tabsTrigger}>
                        Sales Channels
                    </Tabs.Trigger>
                    <Tabs.Trigger value="ads" className={styles.tabsTrigger}>
                        Ads Channels
                    </Tabs.Trigger>
                </Tabs.List>

                <Tabs.Content value="sales" className={styles.tabsContent}>
                    {/* Shopify Integration */}
                    <ShopifyIntegration connectedStore={connectedStore} />

                    {/* BigCommerce Integration */}
                    <BigCommerceIntegration
                        onConnect={() => {
                            console.log('BigCommerce connected');
                        }}
                        onDisconnect={() => {
                            console.log('BigCommerce disconnected');
                        }}
                    />

                    {/* Other Sales Channels */}
                    {salesChannels.map((integration: typeof salesChannels[0], index: number) => (
                        <IntegrationCard
                            key={index}
                            title={integration.title}
                            subtitle={integration.subTitle}
                            icon={integration.icon}
                            status="coming-soon"
                        />
                    ))}
                </Tabs.Content>

                <Tabs.Content value="ads" className={styles.tabsContent}>
                    {/* Google Ads Integration */}
                    <GoogleAdsIntegration
                        onConnect={() => {
                            console.log('Google Ads connected with access token');
                        }}
                        onDisconnect={() => {
                            console.log('Google Ads disconnected');
                        }}
                    />

                    {/* Other Ads Channels */}
                    {adsChannels.map((integration: typeof adsChannels[0], index: number) => (
                        <IntegrationCard
                            key={index}
                            title={integration.title}
                            subtitle={integration.subTitle}
                            icon={integration.icon}
                            status="coming-soon"
                        />
                    ))}
                </Tabs.Content>
            </Tabs.Root>
        </div>
    );
}